import React, { Component, PropTypes } from 'react';
import { SparkTextInput } from '../ui/spark';

class ReactSparkTextInput extends Component {
    componentDidMount() {
        this.textInput = new SparkTextInput(this.textInputMount);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.successMessage !== this.props.successMessage && !!this.props.successMessage) {
            this.textInput.setSuccess(this.props.successMessage);
        } else if (prevProps.errorMessage !== this.props.errorMessage && !!this.props.errorMessage) {
            this.textInput.setError(this.props.errorMessage);
        } else if (prevProps.warningMessage !== this.props.warningMessage && !!this.props.warningMessage) {
            this.textInput.setWarning(this.props.warningMessage);
        }
    }

    render() {
        const {
            changeClass,
            className,
            isDisabled,
            label,
            name,
            placeholder,
            value,
            onBlur,
            onChange,
            onClick,
            onFocus,
            type
        } = this.props;
        const inputClassName = changeClass ? 'spark-input__field change-border-color' : 'spark-input__field';

        return (
            <div className={className}>
                <label className="spark-input" ref={node => (this.textInputMount = node)}>
                    <input
                        disabled={isDisabled}
                        className={inputClassName}
                        name={name}
                        placeholder={placeholder}
                        onChange={onChange}
                        onClick={onClick}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        value={value}
                        type={type}
                    />
                    <span className="spark-label">{label}</span>
                </label>
            </div>
        );
    }
}

ReactSparkTextInput.propTypes = {
    changeClass: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func
};

ReactSparkTextInput.defaultProps = {
    changeClass: '',
    className: '',
    isDisabled: false,
    label: '',
    name: '',
    placeholder: '',
    type: 'text',
    value: '',
    onBlur: () => {},
    onChange: () => {},
    onClick: () => {},
    onFocus: () => {}
};

export default ReactSparkTextInput;



// WEBPACK FOOTER //
// ./src/components/widgets/ReactSparkTextInput.js